import { Outlet } from "react-router-dom";
import './OC.css';

function OC() {
  return (
    <div className="OC hide-scrollbar" id="OC">
      <Outlet />
    </div>
  );
}

export default OC;
